import { NgIf, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { fromEvent, merge, Observable, Observer } from 'rxjs';
import { map } from 'rxjs/operators';
import { SpinnerComponent } from './shared/components/core/spinner/spinner.component';
import { MessageType } from './shared/services/ui/message/message';
import { MessageService } from './shared/services/ui/message/message.service';

@UntilDestroy()
@Component({
  selector:      'app-root',
  templateUrl:   './app.component.html',
  styleUrls:     ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone:    true,
  imports:       [
    SpinnerComponent,
    NgIf,
    RouterOutlet
  ]
})
export class AppComponent {
  private llapi = inject(LowLevelApi);
  private messageService = inject(MessageService);

  private cmwConnectedDialogRef;

  private NETWORK_ERROR_TEXT = 'Die Verbindung zum Server wurde unterbrochen.\nEs wird automatisch versucht sich neu zu verbinden. ' +
    'Falls die Verbindung für längere Zeit unterbrochen sein sollte, kontrollieren Sie bitte ihre Internetverbindung oder wenden Sie sich gegebenenfalls an das Endbenutzerservice.';

  public isIframe: boolean;

  constructor() {

    registerLocaleData(localeDe);
    this.llapi.patchValue('layout.spinner', true);
    //  This is to avoid reload during acquireTokenSilent() because of hidden iframe
    this.isIframe = window !== window.parent && !window.opener;
    this.createOnline$()
      .subscribe(isOnline => {
        if (isOnline && this.cmwConnectedDialogRef) {
          this.cmwConnectedDialogRef.close();
          this.messageService.showSnackBar({
            id:   '@@UI17-connection-success',
            text: 'Verbindung hergestellt.',
            icon: 'wifi',
            type: MessageType.SUCCESS
          });
        } else if (!isOnline) {
          this.cmwConnectedDialogRef = this.messageService.showDialog({
            id:       'serverUnreachable',
            headline: 'Keine Verbindung zum Server',
            text:     this.NETWORK_ERROR_TEXT,
            icon:     'wifi_off'
          }, {
            disableClose: true,
            panelClass:   'dialog-overlay-800px-panel',
            data:         {buttonConfig: {visible: false}}
          });
        }
      });
  }

  private createOnline$() {
    return merge(
      fromEvent(window, 'offline')
        .pipe(map(() => false)),
      fromEvent(window, 'online')
        .pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }
}
